import React, { useEffect, useMemo, useState, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
// import uploadIcon from "../../assets/upload_img.svg";
import { ImUpload2 } from "react-icons/im";
import Tabs from "./TabBar";
import { Header } from "../../components/header/Header";
import { createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategoriesThunk as onGetAllCategoriesThunk } from "../../slices/category/thunk";
import { userContestThunk as onUserContestThunk } from "../../slices/contest/thunk";
import { useNavigate, useLocation , useParams  } from "react-router-dom";
import { Spinner } from "../../components/spinner/Spinner";
import { getAuthUser, getUserSubscribePlan } from "../../utils/GetAuthUser";
import { getRole } from "../../utils/GetRole";
import { getUserListThunk } from "../../slices/artists/thunk";


const initialValues = {
  categoryId: "",
  idea: "",
  media: [],
  selectedUserId: "", // Only used when role is admin
};

const validationSchema = Yup.object().shape({
  categoryId: Yup.string().required("Please select a category"),
  idea: Yup.string().required("Please enter your idea"),
  media: Yup.array()
    .min(1, "Please upload at least one image")
    .max(2, "You can upload maximum two images")
    .required("Please upload at least one image")
    .test('fileSize', 'Each image must be less than 5MB', function(value) {
      if (!value || value.length === 0) return true;
      
      // Check each file individually
      for (let file of value) {
        if (file && file.size > 5 * 1024 * 1024) { // 5MB in bytes
          return this.createError({
            message: `${file.name} exceeds 5MB limit`,
          });
        }
      }
      return true;
    })
   
});

export const UserHome = () => {

  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isShowLoader, setIsShowLoader] = useState(false);
  const [isRedirectAllow, setIsRedirectAllow] = useState(false)
  const [connectedEvenId, setConnectedEvenId] = useState(null)

  const authUser = getAuthUser();
  const userSubscribePlan = getUserSubscribePlan();
  const role=getRole()


  const selectCategoryState = (state) => state.category;
  const selectContestState = (state) => state.contest;

  const categoriesSelector = createSelector(
    selectCategoryState,
    (category) => ({
      isLoading: category.isLoading,
      categoriesList: category.categoriesList,
    })
  );

  const contestSelector = createSelector(selectContestState, (contest) => ({
    isLoading: contest.isLoading,
    isSuccess: contest.isSuccess,
    newContest: contest.newContest,
  }));

  const { categoriesList } = useSelector(categoriesSelector);
  const { isLoading, isSuccess, newContest } = useSelector(contestSelector);

  useEffect(() => {
    dispatch(onGetAllCategoriesThunk());
  }, [dispatch]);

  useEffect(() => {
    setCategories(categoriesList);
  }, [categoriesList]);

  const handleSubmit = (values) => {
   
    const formData = new FormData();
    // Role-based user and publish logic
    if (role === "admin") {
      if (!values.selectedUserId) {
        alert("Please select a user from the dropdown.");
        return;
      }
      formData.append("userId", values.selectedUserId);
      formData.append("is_publish", 1);
      formData.append("status", 140);
    } else {
  
      formData.append("userId", authUser?.user?.id);
      formData.append("is_publish", userSubscribePlan == "premium" ? 2 : 1);
    }

      formData.append("description", values.idea);
      formData.append("category[]", values.categoryId);
      formData.append("status", 140);
       formData.append("event_id", connectedEvenId?? null);
        formData.append("discount",  0);
      values.media.forEach((file) => formData.append("media[]", file));

      

    dispatch(onUserContestThunk(formData));

  };

  const location = useLocation();
  const params = useParams();
  
  // Fetch event details when URL param changes
  useEffect(() => {
    if (location.pathname.includes("connected-event") && params.eventId) {

      setConnectedEvenId(params.eventId);


      
      
   
  }

}, [connectedEvenId]);

  useEffect(() => {
    setIsShowLoader(isLoading);
  }, [isLoading]);


  useEffect(() => {
    if (isSuccess && newContest) {
    setIsRedirectAllow(true);
    }
  }, [isSuccess, newContest,userSubscribePlan]);


    //isRedirectAllow
      useEffect(() => {
      if (isRedirectAllow) {
          if (userSubscribePlan == "premium") {
        navigate(`/user/contest-artist-request/${newContest}`);
      } else {
        navigate(`/user/contest-detail/2/${newContest}`);
      }
      }
      setIsRedirectAllow(false)
    }, [isRedirectAllow,navigate])

    const selecUserState = (state) => state.user;
        const userSelector = createSelector(selecUserState, (user) => ({
          users: user.users,
        }));
    
          const { users } = useSelector(userSelector);
    
          useEffect(() => {
          dispatch(getUserListThunk({ userType:1}));
        }, [dispatch]);


      const userOptions = useMemo(() => {

    if (!users || !Array.isArray(users)) return [];
    return users.map((user) => ({
      id: user.withoutEncryptId,
      name: user.name,

    }));
  }, [users]);
    
  


  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
        <Header name={authUser?.user?.name} />
      </header>

      <div className="w-full  mx-auto bg-[#F7F7F7]">
        <div className="w-full flex items-center justify-center mt-4">
          <h1 className="text-black text-xl sm:text-3xl font-bold font-grotesk">
            Transform <span className="text-primary">Idea to Visual</span>
          </h1>
        </div>

        <div className="w-full flex flex-col items-center justify-center mt-1">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form className="w-full flex flex-col items-center justify-center mt-4">
                {/* Admin: Select User Dropdown */}
                {role === "admin" && (
                  <div className="w-full max-w-[750px] mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Select User</label>
                    <Field
                      as="select"
                      name="selectedUserId"
                      className="w-full border border-border_color rounded-[10px] p-2 bg-white"
                    >
                      <option value="">-- Select a user --</option>
                      {userOptions.map((u) => (
                        <option key={u.id} value={u.id}>{u.name}</option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="selectedUserId"
                      component="div"
                      className="text-red-500 text-xs mt-1"
                    />
                  </div>
                )}
                {/* ✅ Categories */}
                <div className="flex gap-2 flex-wrap">
                  {categories.map((option) => {
                    // const isSelected = values.categoryId.includes(option.id.toString());
                    const isSelected =
                      values.categoryId === option.id.toString();
                    return (
                      <label
                        key={option.id}
                        className={`flex items-center justify-center border py-[8px] px-[18px] rounded-3xl font-bold text-sm tracking-wide font-grotesk whitespace-nowrap cursor-pointer
                          ${
                            isSelected
                              ? "border-secondary text-secondary bg-[#dddddd8c]"
                              : "border-[#DDDDDD] text-[#262626]"
                          }`}
                      >
                        <Field
                          type="radio"
                          name="categoryId"
                          value={option.id.toString()}
                          className="hidden"
                        />
                        {option.title}
                      </label>
                    );
                  })}
                </div>
                <ErrorMessage
                  name="categoryId"
                  component="div"
                  className="text-red-500 text-xs mt-1"
                />

                {/* ✅ Idea input */}
                <div className="w-full flex items-center justify-center mt-5">
                  <div className="w-full max-w-[750px] border border-border_color py-0 px-2 rounded-2xl bg-[#F7F7F7]">
                    <div className="w-full flex flex-col">
                      <Field
                        as="textarea"
                        name="idea"
                        rows={3}
                        placeholder="Type your idea, click 'Create' to get a video"
                        className="w-full max-w-[750px] resize-none p-3 rounded-xl bg-transparent outline-none text-sm "
                      />
                      <ErrorMessage
                        name="idea"
                        component="div"
                        className="text-red-500 text-xs mt-1"
                      />

                      {/* ✅ Preview Images */}
                      {values.media && values.media.length > 0 && (
                        <div className="flex gap-3 mt-3 flex-wrap">
                          {values.media.map((file, index) => (
                            <div key={index} className="relative">
                              <img
                                src={URL.createObjectURL(file)}
                                alt="preview"
                                className="w-20 h-20 object-cover rounded-md border"
                              />
                              <button
                                type="button"
                                onClick={() => {
                                  const updatedFiles = values.media.filter(
                                    (_, i) => i !== index
                                  );
                                  setFieldValue("media", updatedFiles);
                                }}
                                className="absolute top-0 right-0 bg-primary text-white rounded-full w-5 h-5 flex items-center justify-center text-lg font-semibold"
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="flex items-center justify-between mt-2 gap-3 flex-wrap sm:flex-nowrap px-3 mb-4">
                        {/* ✅ File upload */}
                        <div className="flex items-center justify-between mt-2">
                          <label
                            htmlFor="file-upload"
                            className="cursor-pointer text-gray-500 hover:text-secondary flex items-end gap-2"
                          >
                            <span>
                              {/* <img src={uploadIcon} alt="upload" /> */}
                              <ImUpload2 className="text-xl font-bold text-secondary" />
                            </span>
                            <span className="text-black text-xs sm:text-[16px] font-medium font-grotesk">
                              Upload your image
                            </span>
                          </label>
                          <input
                            id="file-upload"
                            name="media"
                            type="file"
                            accept="image/png, image/jpeg, image/jpg"
                            multiple
                            className="hidden"
                            onChange={(event) => {
                              const newFiles = Array.from(
                                event.currentTarget.files
                              );
                              const totalFiles = [
                                ...(values.media || []),
                                ...newFiles,
                              ];

                              if (totalFiles.length > 2) {
                                alert("You can upload only 2 images.");
                                return;
                              }

                              setFieldValue("media", totalFiles);
                            }}
                          />
                        </div>
                        <ErrorMessage
                          name="media"
                          component="div"
                          className="text-red-500 text-xs mt-1"
                        />

                        {/* ✅ Submit button */}
                        <button
                          type="submit"
                          className="bg-primary text-white px-5 py-3 rounded-[10px] text-xs font-medium mt-3 tracking-wide"
                          disabled={isShowLoader}
                        >
                          {isShowLoader ? <Spinner /> : "Submit"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>

       {role=='user'?
          <div className="mt-20 flex items-start justify-start w-full ">
            <Tabs />
          </div>
          :''}
        </div>
      </div>
    </>
  );
};
